import { createSlice } from "@reduxjs/toolkit";
import { createUserThunk, getUsersThunk, updateUserThunk } from "../actions/user.action";

// Types
export interface User {
  _id: string;
  fullName: string;
  email: string;
  role: number;
}

export interface UserState {
  users: {
    data: User[];
    pagination: {
      totalItems: number;
      totalPages: number;
      pageSize: number;
      currentPage: number;
    };
  };
  loading: boolean;
  error: string | null;
}

// Initial state
const initialState: UserState = {
  users: {
    data: [],
    pagination: {
      totalItems: 0,
      totalPages: 0,
      pageSize: 0,
      currentPage: 0,
    },
  },
  loading: false,
  error: null,
};

// Auth slice
const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Get users
      .addCase(getUsersThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getUsersThunk.fulfilled, (state, action) => {
        state.loading = false;
        state.users = action.payload.data;
        state.error = null;
      })
      .addCase(getUsersThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      });
    // Create user
    builder
      .addCase(createUserThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(createUserThunk.fulfilled, (state, action) => {
        state.loading = false;
        state.error = null;
      })
      .addCase(createUserThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      });
    // Update user
    builder
      .addCase(updateUserThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateUserThunk.fulfilled, (state, action) => {
        state.loading = false;
        state.users.data = state.users.data.map((user) => {
          if (user._id === action.payload.data._id) {
            return action.payload.data;
          }
          return user;
        });
        state.error = null;
      })
      .addCase(updateUserThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      });
  },
});

export const {} = userSlice.actions;
export default userSlice.reducer;
